
import { Toast } from 'mint-ui'

export const locationMixin = {
	data () {
		return {

		}
	},
	created () {

	},
	methods: {
		getLocation (cb, fail, showToast = false,) {
            if (showToast) Toast({message: '正在定位', duraion: 2000});
            this.getCurrentPosition().then(res => {
                cb && cb(res.city.replace('市', ''))
            }).catch((err) => {
                if (showToast) Toast({message: '定位失败', duraion: 2000})
                fail && fail()
            })
        },
        getCurrentPosition () {
            let _this = this
            return new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(
                  function (position) {
                    _this.getLocationForPoint(position.coords.latitude, position.coords.longitude).then((res) => {
                      resolve({ ...res, ...res.addressComponents, ...res.point });
                    });
                  },
                  function (error) {
                    console.log(error)
                    reject(error);
                  },
                  {
                    enableHighAccuracy: true,
                    timeout: 12000,
                    maximumAge: 600000,
                  }
                );
            });
        },
        getLocationForPoint (lat, lng) {
            return new Promise((resolve, reject) => {
                const myGeo = new BMap.Geocoder();
                // 根据坐标得到地址描述
                myGeo.getLocation(new BMap.Point(lng, lat), function (result) {
                    if (result) {
                        resolve(result);
                    }
                });
            });
        }
	}
}


// WEBPACK FOOTER //
// ./src/mixins/location.js